<script setup lang="ts">
import { computed } from "vue"
import { Pie } from "vue-chartjs"

import { ArcElement, Chart as ChartJS, Legend, Title, Tooltip } from "chart.js"

ChartJS.register(ArcElement, Tooltip, Legend, Title)

const props = defineProps({
  labels: { type: Array<String>, default: () => [], required: true },
  values: { type: Array<number>, default: () => [], required: true },
  title: { type: String, default: "" },
  // Optional: provide your own colors; otherwise defaults keep [blue, red] first.
  colors: { type: Array<String>, default: () => [] },
})

// Bootstrap-aligned palette; first two are blue/red
const defaultPalette = [
  "#0d6efd", // blue (primary)
  "#dc3545", // red (danger)
  "#198754", // green
  "#ffc107", // yellow
  "#20c997", // teal
  "#6f42c1", // purple
  "#fd7e14", // orange
  "#0dcaf0", // cyan
  "#6c757d", // gray
  "#343a40", // dark
]

const bgColors = computed(() => {
  const palette = props.colors.length ? props.colors : defaultPalette
  return props.values.map((_, i) => String(palette[i % palette.length]))
})

const data = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: props.title || "Series",
      data: props.values,
      backgroundColor: bgColors.value,
      borderColor: "#fff",
      borderWidth: 1,
    },
  ],
}))

const options = computed(() => ({
  responsive: true,
  maintainAspectRatio: false, // square enforced by Bootstrap ratio wrapper
  plugins: {
    legend: { display: true, position: "bottom" as const },
    title: { display: !!props.title, text: props.title },
  },
  // For donut style, add: cutout: "50%"
}))
</script>

<template>
  <!-- Bootstrap 5: forces a perfect square box -->
  <div class="ratio ratio-1x1">
    <Pie :data="data" :options="options" />
  </div>
</template>

<style scoped></style>
